import schema from 'schm';
import translate from 'schm-translate';

const patientAddressPrediction = schema(
  {
    name: String,
    id: String,
    typeof: 'patient',
  },
  translate({
    name: 'description',
    id: 'place_id',
  }),
);

export default patientAddressPrediction;
